import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { withRouter } from 'react-router-dom';
import { DatePicker } from 'antd';
import { getCampaignListAction } from '../../../../../actions';
import { formFields } from './constant'; // Import your formFields constant
import Input from '../../../../../components/FormElements/Input'
import SelectNew from '../../../../../components/FormElements/SelectNew'
import Datepicker from '../../../../../components/FormElements/Datepicker';
import { getCurrentDateInTimeZone, getDateFromUtcToSpecificZone, getDateInUtcFormat, getUserSelectedDateInUtc, isApiCallSuccess, isDateSame, isTenantDemoAdvertiser } from "../../../../../selectors";
import { basicDetailsReduxAction } from '../../../../../actions/basicDetails';

import { initializeForm, handleFieldError, handleError } from '../../../../../utils/form-validation';

import {
  getCategoryAction,
  getCampaignCategoryTypeAction,
  getCampaignSubCategoryAction,
  getSUbCategoryAction,
  getDataConfigAction,
  getAllCurrencyAction,
} from '../../../../../actions';
import { useDataConfigListAll } from '../../../../../hooks/useDataConfigListAll';
import {useFetchInfomateryData} from '../../../../../hooks/useFetchInfomateryData';
import { configKeys } from '../../../../../helpers/config/configKeys';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import { reduxDrawerAction } from '../../../../../actions/campaign';
import { infoKeys } from '../../../../../helpers/config/infomateryKeys';
import asyncRoute from '../../../../../helpers/hoc/asyncRoute';
import {campaignList} from "../../../../../constants/demo/campaignData"


const StepOneContent = ({targetTimeZone,...props}) => {
  // Create state variables for input values
  const [campaignName, setCampaignName] = useState('');
  const [brandName, setBrandName] = useState('');
  const [objective, setObjective] = useState('');
  const [goalValue, setGoalValue] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({ /* initial errors state */ });
  const [submited, setSubmited] = useState(false);
  const [form, setForm] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [objectiveData, setObjectiveData] = useState([]);
  const [businessTypeData, setBusinessTypeData] = useState([]);
  const [dateData, setDateData] = useState({
    currentDate: new Date(),
    fetchedStartDate:"",
    fetchedEndDate:"",
    fetchedStartDateInUtc: "",
    fetchedEndDateInUtc: ""
  })
  const [campaignInfoData, setCampaignInfoData] = useState({});
  const basicDetailsForm = useSelector(state => get(state, 'app.basicDetailsForm', {}));
  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));

  const reduxConfigData = useDataConfigListAll();
  const reduxInfoData = useFetchInfomateryData();

  const dispatch = useDispatch();


  const InfoButton = asyncRoute(()=> import('../../../../../components/InfoButton'));

  const isFormComplete = () => {

    // Validate the form using the handleError function
    let { errors, valid } = handleError(form, formFields);

    // console.log("errors:", errors);
    // console.log("valid:", valid);

    // Check if the form is both complete and valid

    // for StartDate **********************

    form["isStartDateChanged"] = !isDateSame(form.startDate,dateData.fetchedStartDate);
    form["isEndDateChanged"] = !isDateSame(form.endDate,dateData.fetchedEndDate);
    form["fetchedStartDate"] = dateData.fetchedStartDateInUtc;
    form["fetchedEndDate"] = dateData.fetchedEndDateInUtc;

    // Validation for totalBudget when value is less than 1.
    if(form["totalBudget"] < 1){
      setErrors({ ...errors, [formFields.totalBudget.key]: { min: true } });
      setTouched({ ...errors, [formFields.totalBudget.key]:  true  });
      valid = false;
    }
    
    if(isDateSame(form.startDate, form.endDate)){
      form["isEndDateChanged"] = true;
    }

    if (valid) {
      props.setBasicDetailsInParent(form)
    }

    return valid;
  };

  const isDemoAdvertiser = useMemo(() => {
      return isTenantDemoAdvertiser(tenantId);
    }, [tenantId]);
  
  useEffect(()=>{
    if(reduxInfoData && !Object.keys(campaignInfoData).length > 0){
      if(reduxInfoData.campaignScreen && reduxInfoData.campaignScreen.beki && reduxInfoData.campaignScreen.beki.basicDetails){
        setCampaignInfoData(reduxInfoData.campaignScreen.beki.basicDetails);
      }
    }
  },[reduxInfoData])

  useEffect(() => {  
    if(targetTimeZone){
    const currentDateTime = getCurrentDateInTimeZone(targetTimeZone);
    setDateData({...dateData,currentDate:currentDateTime});
    initializeListApiCall();
    }
  }, [targetTimeZone]);


  useEffect(() => {
    // When any input changes, update the parent with the form completion status
    props.onFormCompletion(isFormComplete());
  }, [form])

  useEffect(() => {
    const { match: { params: { id } } } = props;
    if(isDemoAdvertiser){
      if(props.location.pathname.includes('view-campaign') || props.location.pathname.includes('edit-campaign')){
        const mandate = campaignList.find(item => item.campaignId == id);
        if(mandate){
          let startDate= mandate.startDate ? moment(getDateFromUtcToSpecificZone({date:mandate.startDate,targetTimeZone:targetTimeZone})).toDate() : "";
          let endDate = mandate.endDate ? moment(getDateFromUtcToSpecificZone({date:mandate.endDate,targetTimeZone:targetTimeZone})).toDate() : "";
          let basicDetailsForm = ({
            [formFields.campaignName.key]: mandate.campaignName || "",
            [formFields.brandName.key]: mandate.brandName || "infomoDemo",
            [formFields.goal.key]: mandate.goal || "355",
            [formFields.goalValue.key]: mandate.goalValue || "0.2",
            [formFields.startDate.key]: startDate,
            [formFields.endDate.key]: endDate,
            [formFields.totalBudget.key]: mandate.budget || "",
            [formFields.businessType.key]: mandate.businessType || "351",
            [formFields.brandUrl.key]: mandate.brandUrl || "https://devbeki.torcai.com/atd",
            [formFields.category.key]: mandate.category || "160",
            [formFields.subcategory.key]: mandate.subcategory || "161",
            campaignIdCreated: mandate.campaignId
          });
          setDateData((prevData)=>{
            return {
            ...prevData,
            fetchedStartDate:startDate,
            fetchedEndDate:endDate,
            fetchedStartDateInUtc:mandate.startDate ? mandate.startDate : "",
            fetchedEndDateInUtc:mandate.endDate ? mandate.endDate : ""
          }})
          dispatch(
            basicDetailsReduxAction({
              basicDetailsForm
            })
          );
          return
        }else{
          getCampaignData(id);
          return;
        }
      }
    }

    if (id) {
      getCampaignData(id);
    }
  }, []);

  useEffect(() => {
    const { match: { params: { id } } } = props;
    // const { form, errors } = initializeForm(formFields);
    // setForm(form);
    // setErrors(errors);
    if (basicDetailsForm && Object.keys(basicDetailsForm).length > 0) {
      setForm({ ...form, ...basicDetailsForm });
      subCategoryApiFunction(basicDetailsForm.category)
    }
  }, [basicDetailsForm]);

  useEffect(() => {
    if (reduxConfigData) {
      dataConfigApiFunction();
    }
  }, [reduxConfigData])

  const initializeListApiCall = async () => {
    await categoryApiFunction();
    await getCurrencyApiFunction();
  }

  const dataConfigApiFunction = async () => {

    const {
      response = [],
    } = reduxConfigData;

    if (response.length > 0) {

      const objectiveResponse = response.filter(item =>
        item.name == configKeys.Objective
      );
      if (objectiveResponse) {
        setObjectiveData(objectiveResponse[0].list);
      }

      const businessTypeResponse = response.filter(item =>
        item.name == configKeys.Business_Type
      );
      if (businessTypeResponse) {
        setBusinessTypeData(businessTypeResponse[0].list);
      }
    } else {
      console.log("List data not found");
    }
  }

  const getCurrencyApiFunction = async () => {
    await dispatch(getAllCurrencyAction({ tenantId, authToken, userId })).then((data) => {
      const {
        responseCode: { status = "" },
        responseList,
      } = data;

      const PreSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
      const matchingTenant = PreSignInData.responseList.find(item => item.tenantId == tenantId);
      // console.log(matchingTenant);

      if (matchingTenant) {
        const matchingCurrency = responseList.find(item => item.key == matchingTenant.currencyType);
        // console.log(matchingCurrency);
        localStorage.setItem('currency', JSON.stringify(matchingCurrency));
      }
    });
  }

  const getCampaignData = async (id) => {
    let params = { list: 'id', id };
    await dispatch(getCampaignListAction({ tenantId, authToken, userId, params })).then((data) => {
      // console.log("data", data)
      const {
        responseCode: { status = "" },
        responseObj,
      } = data;

      if (isApiCallSuccess(status)) {
        const { mandate } = responseObj;
        if (mandate) {
          const startDate = mandate.startDate ? moment(getDateFromUtcToSpecificZone({date:mandate.startDate,targetTimeZone:targetTimeZone})).toDate() : "";
          const endDate = mandate.endDate ? moment(getDateFromUtcToSpecificZone({date:mandate.endDate,targetTimeZone:targetTimeZone})).toDate() : "";
          let mandateData = {
            ...mandate,
            startDate: startDate,
            endDate: endDate
          };

          setDateData((prevData)=>{
            return {
            ...prevData,
            fetchedStartDate:startDate,
            fetchedEndDate:endDate,
            fetchedStartDateInUtc:mandate.startDate ? mandate.startDate : "",
            fetchedEndDateInUtc:mandate.endDate ? mandate.endDate : ""
          }})

          let basicDetailsForm = { ...mandateData, campaignIdCreated: mandate.campaignId };
          dispatch(
            basicDetailsReduxAction({
              basicDetailsForm
            })
          );
        }
      } else {
        console.log("Campaign List by Id Api failed!");
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  const handleTouch = (e) => {
    const { name, value } = e.target;
    const { error } = handleFieldError(value, formFields[name]);

    setErrors({ ...errors, [name]: error });
    setTouched({ ...touched, [name]: true });
  };

  const handleChange = (e) => {
    const { value, name, min } = e.target;
    const categoryValue = e.target.value;
    // console.log("categoryValue0", categoryValue)
    // console.log("categoryData", categoryData)

    const filterCategory = categoryData.filter(cat => {
      return cat.key == categoryValue
    })

    // console.log("filterCategory", filterCategory)

    if (filterCategory.length > 0) {
      filterCategory.map(data => {
        subCategoryApiFunction(data.key)
      })
    }
    // if (min) {
    //   value = Math.max(Number(min), Number(value));
    // }
    setForm((prev) => {
      return {
        ...prev, [name]: value
      }
    }
    );
    if (name == formFields.category.key) {
      setForm((prev) => {
        return {
          ...prev, subcategory: ""
        }
      }
      );
    }
  };

  const categoryApiFunction = async () => {
    await dispatch(getCampaignCategoryTypeAction({ tenantId, authToken, userId })).then((data) => {

      // console.log("data", data)
      const {
        responseCode: { status = "" },
        responseList,
      } = data;

      if (status.toLowerCase() === "success") {

        // const categoryListDropdownData = responseList.map((item, index) => {
        //   return { text: item.value, categoryID: item.id };
        // });
        setCategoryData(responseList);
      } else {
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
      });

  }

  const subCategoryApiFunction = async (cateID) => {

    let payload = {
      list: [cateID]
    }

    await dispatch(getCampaignSubCategoryAction({ tenantId, authToken, userId, payload, addParams: {} })).then((data) => {
      // console.log("new a", cateID);
      // console.log("data", data)
      const {
        responseCode: { status = "" },
        responseList = [],
      } = data;

      // console.log(responseList)

      if (status.toLowerCase() === "success" && responseList.length > 0) {

        // const subCategoryListDropdownData = responseList.map((item, index) => {
        //   return { text: item.value, categoryID: item.id };
        // });
        setSubCategoryData(responseList);
      } else {
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
      });
  }

  const openInformationModal = (text = "") => {
    dispatch(reduxDrawerAction({ showDragger: true, data: text }));
  };


  const infoButtonBooleanData = useMemo(() => {
    let infoObj = {};
    if (Object.keys(campaignInfoData).length > 0) {
      Object.keys(campaignInfoData).map((data) => {
        if (campaignInfoData[data] && campaignInfoData[data].length > 0) {
          infoObj[data] = true;
        }
      });
    }

    return infoObj;
  }, [campaignInfoData]);

  // console.log("form", form)
  const currency = JSON.parse(localStorage.getItem('currency'));
  const { match :{ params: { id }}} = props;

  return (
    <div className='row'>
      <div className={`row ${props.isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
        <div className="col-md-6">
          <Input
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.campaignName.key] ? form[formFields.campaignName.key] : ''}
            setting={formFields[formFields.campaignName.key]}
            error={errors[formFields.campaignName.key]}
            submited={submited}
            touched={touched[formFields.campaignName.key]}
            infoIcon={infoButtonBooleanData[infoKeys.campaignName]}
            onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.campaignName]
                    );
                  }}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.brandName.key]}
            setting={formFields[formFields.brandName.key]}
            error={errors[formFields.brandName.key]}
            submited={submited}
            touched={touched[formFields.brandName.key]}
            infoIcon={infoButtonBooleanData[infoKeys.brandName]}
            onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.brandName]
                    );
                  }}
          />
        </div>
        <div className="col-md-6 ">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.goal.key]}
            setting={formFields[formFields.goal.key]}
            error={errors[formFields.goal.key]}
            submited={submited}
            touched={touched[formFields.goal.key]}
            options={objectiveData}
            infoIcon={infoButtonBooleanData[infoKeys.goal]}
            onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.goal]
                    );
                  }}
          />
        </div>

        <div className="col-md-6 ">
          <Input
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.goalValue.key]}
            setting={formFields[formFields.goalValue.key]}
            error={errors[formFields.goalValue.key]}
            submited={submited}
            touched={touched[formFields.goalValue.key]}
            infoIcon={infoButtonBooleanData[infoKeys.goalValue]}
            onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.goalValue]
                    );
                  }}
          />
        </div>
        <div className="col-md-6 mt-4">
          <Datepicker
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.startDate.key] || ''}
            setting={formFields[formFields.startDate.key]}
            error={errors[formFields.startDate.key]}
            submited={submited}
            touched={touched[formFields.startDate.key]}
            minDate={moment(dateData.currentDate).toDate()}
            maxDate={form.end == '' ? new Date() : form.endDate}
            showDisabledMonthNavigation
            disabled={id ? (basicDetailsForm.isRecActive == 2 ? false: true ): false}
            infoIcon={infoButtonBooleanData[infoKeys.startDate]}
            onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.startDate]
                    );
                  }}
          />
        </div>
        <div className="col-md-6 mt-4">
          <Datepicker
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.endDate.key] || ''}
            setting={formFields[formFields.endDate.key]}
            error={errors[formFields.endDate.key]}
            submited={submited}
            touched={touched[formFields.endDate.key]}
            isDisabled={form.startDate ? false : true}
            // minDate={props.id ? new Date() : form.startDate == '' ? new Date() : form.startDate}
            minDate={!form.startDate ? moment(dateData.currentDate).toDate() : moment(form.startDate).isBefore(moment(dateData.currentDate).toDate()) ? moment(dateData.currentDate).toDate() : form.startDate}
            sDate={form.startDate}
            disabled={id ? ((basicDetailsForm.isRecActive == 2 || basicDetailsForm.isRecActive == 3) ? false: (moment(basicDetailsForm.endDate).isBefore(moment(dateData.currentDate).format('YYYY-MM-DD')) ? true : false)): false}
            infoIcon={infoButtonBooleanData[infoKeys.endDate]}
            onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.endDate]
                    );
                  }}
          />
        </div>
      </div>
      <div class="accordion mt-3 accordion-bordered details-accordion" id="accordionStyle1">
        <div class="accordion-item card mb-0">
          <h2 class="accordion-header">
            <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-1" aria-expanded="false">
              <div className='d-flex justify-content-between w-100' style={{ fontSize: 14 }}>
                BUSINESS DETAILS
                {(form.businessType !== "" &&
                  form.brandUrl &&
                  form.category &&
                  form.subcategory) ? <div className="details-adj">Details added</div> : <></>}
              </div>
            </button>
          </h2>

          <div id="accordionStyle1-1" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
            <div className={`accordion-body ${props.isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
              <div className='row'>
                <div className="col-md-6 ">
                  <SelectNew
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.businessType.key]}
                    setting={formFields[formFields.businessType.key]}
                    error={errors[formFields.businessType.key]}
                    submited={submited}
                    touched={touched[formFields.businessType.key]}
                    options={businessTypeData}
                    infoIcon={infoButtonBooleanData[infoKeys.businessType]}
                    onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.businessType]
                    );
                  }}
                  />
                </div>
                <div className="col-md-6 ">
                  <Input
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.brandUrl.key]}
                    setting={formFields[formFields.brandUrl.key]}
                    error={errors[formFields.brandUrl.key]}
                    submited={submited}
                    touched={touched[formFields.brandUrl.key]}
                    infoIcon={infoButtonBooleanData[infoKeys.brandUrl]}
                    onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.brandUrl]
                    );
                  }}
                  />
                </div>
                <div className="col-md-6 ">
                  <SelectNew
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.category.key]}
                    setting={formFields[formFields.category.key]}
                    error={errors[formFields.category.key]}
                    submited={submited}
                    touched={touched[formFields.category.key]}
                    options={categoryData}
                    infoIcon={infoButtonBooleanData[infoKeys.businessCategory]}
                    onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.businessCategory]
                    );
                  }}
                  />
                </div>
                <div className="col-md-6 ">
                  <SelectNew
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.subcategory.key]}
                    setting={formFields[formFields.subcategory.key]}
                    error={errors[formFields.subcategory.key]}
                    submited={submited}
                    touched={touched[formFields.subcategory.key]}
                    options={subCategoryData}
                    infoIcon={infoButtonBooleanData[infoKeys.businessSubCategory]}
                    onInfoClick={() => {
                    openInformationModal(
                      campaignInfoData[infoKeys.businessSubCategory]
                    );
                  }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card accordion-item">
          <h2 class="accordion-header">
            <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="false">
              <div className='d-flex justify-content-between w-100' style={{ fontSize: 14 }}>
                BUDGET DETAILS
                {form.totalBudget && <div className="details-adj">Details added</div>}
              </div>
            </button>
          </h2>
          <div id="accordionStyle1-3" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
            <div className={`accordion-body ${props.isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
              <div className='row'>
                <div className="col-md-12">
                  {/* <span style={{ position: "absolute", top: 28, fontSize: 10 }} className='text-primary'>Minimum totalBudget allowed is 500 $</span> */}
                  <div className="form-group row ">
                    <label for="agegroup" class="col-12 col-form-label">
                      {currency ? `Budget (${currency.value})` : 'Budget'} <span class="text-danger">*</span>
                      <InfoButton
                      infoIcon={infoButtonBooleanData[infoKeys.budget]}
                      onInfoClick={() => {
                        openInformationModal(campaignInfoData[infoKeys.budget]);
                      }}
                    />
                    </label>
                  </div>
                  <Input
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.totalBudget.key]}
                    setting={formFields[formFields.totalBudget.key]}
                    error={errors[formFields.totalBudget.key]}
                    submited={submited}
                    touched={touched[formFields.totalBudget.key]}
                    infoIcon={infoButtonBooleanData[infoKeys.budget]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(StepOneContent);




  // useEffect(() => {
  //   const targetTimeZone = "America/Sao_Paulo";
  //   const userCurrentDateTime = momentTimeZone.tz(targetTimeZone);
  //   // console.log(momentTimeZone.tz.guess(),'************');
  //   const dateFormat = userCurrentDateTime.clone().utc().format('YYYY-MM-DD');
  //   console.log(dateFormat,'user Date current after formatted');
  //   console.log('*****************************************************************888')
  //   const datebegin = momentTimeZone.tz(`${dateFormat} 00:00:00`, 'YYYY-MM-DD HH:mm:ss', targetTimeZone)
  //   const dateEnd = momentTimeZone.tz(`${dateFormat} 23:59:59`, 'YYYY-MM-DD HH:mm:ss', targetTimeZone)
  //   console.log(datebegin.format(),'orignal start date');
  //   console.log(dateEnd.format(),'orignal end date');
  //   const UtcDataStart = datebegin.clone().utc().format();
  //   const UtcDataEnd = dateEnd.clone().utc().format()
  //   // console.log(UtcDataStart,'UTC start');
  //   // console.log(UtcDataEnd,'UTC end');
  //   console.log(UtcDataStart);
  //   console.log(UtcDataEnd);
  //   const utcEndFormat = dateEnd.clone().utc().format('YYYY-MM-DD hh:mm:ss');
  //   const utcStartFormat = datebegin.clone().utc().format('YYYY-MM-DD hh:mm:ss');
  //   // console.log(utcStartFormat,utcEndFormat,'utc date format');
  //   // console.log('*******************************************************************')
  //   // console.log(momentTimeZone.utc(utcEndFormat).tz(targetTimeZone).format(),'********end date formated');
  //   // console.log(momentTimeZone.utc(utcStartFormat).tz(targetTimeZone).format(),'********start date formated');
  //   // console.log('*******************************************************************')
  //   // console.log(momentTimeZone.utc(UtcDataStart).tz(targetTimeZone).format(),'********correct date format start date');
  //   // console.log(momentTimeZone.utc(UtcDataEnd).tz(targetTimeZone).format(),'********correct date format end date');



  //   console.log(utcStartFormat,utcEndFormat);

  //   // get time data    

  //   const utcTime = '2024-05-31 02:59:59';
    
  //   // Parse the UTC time
  //   const utcMoment = momentTimeZone.utc(utcTime, 'YYYY-MM-DD HH:mm:ss');
    
  //   // Convert to Sao Paulo time zone
  //   const saoPauloMoment = utcMoment.tz('America/Sao_Paulo');
    
  //   // Format the Sao Paulo time
  //   console.log(saoPauloMoment.format('YYYY-MM-DD HH:mm:ss'));
  //   initializeListApiCall();
  // }, []);